import { Resource } from '../Resource';
import * as methods from '../methods';
import * as me from './me';
const rootPath = 'auth';
const id = (x) => x;
export const toRaw = {
    refreshToken: ({ token }) => ({ token }),
    login: id,
    loginMagic: ({ email }) => ({ email }),
    loginMagicConfirm: ({ token }) => ({ token }),
    register: ({ firstName, lastName, email, password, country, isSubscribedToNewsletter, telephoneCountryCode, telephoneNumber }) => ({
        first_name: firstName,
        last_name: lastName,
        email,
        /** We do not ask for password confirmation */
        password1: password,
        password2: password,
        invoice_country: country,
        newsletter: isSubscribedToNewsletter,
        /** Otherwise we will get validation errors if we only set one of them */
        ...(telephoneCountryCode && telephoneNumber
            ? {
                phone: { country: telephoneCountryCode, number: telephoneNumber }
            }
            : {})
    }),
    resetPassword: ({ email }) => ({ email }),
    sendVerificationEmail: ({ email }) => ({
        email
    }),
    verifyEmail: (form) => form,
    resetPasswordConfirm: ({ password, uid, token }) => ({
        password1: password,
        password2: password,
        uid,
        token
    }),
    changePassword: (body) => ({
        old_password: body.oldPassword,
        password1: body.newPassword,
        password2: body.newPassword
    })
};
export const fromRaw = {
    refreshToken: ({ token }) => ({ token }),
    loginMagicConfirm: ({ jwt }) => ({
        token: jwt
    }),
    loginMagic: () => ({}),
    login: ({ token, user }) => ({
        token,
        me: me.fromRaw.me(user)
    }),
    register: ({ token, user }) => ({
        token,
        me: me.fromRaw.me(user)
    }),
    resetPassword: (x) => x,
    sendVerificationEmail: (x) => x,
    resetPasswordConfirm: (x) => x,
    verifyEmail: ({ verified_email }) => ({
        verifiedEmail: verified_email
    })
};
const fromError = {
    login: (e) => ({
        fieldErrors: {
            email: e.fieldErrors?.email,
            password: e.fieldErrors?.password
        },
        nonFieldErrors: e.nonFieldErrors
    }),
    resetPassword: (e) => ({
        fieldErrors: {
            email: e.fieldErrors?.email
        },
        nonFieldErrors: e.nonFieldErrors
    }),
    sendVerificationEmail: (e) => ({
        fieldErrors: {
            email: e.fieldErrors?.email
        },
        nonFieldErrors: e.nonFieldErrors
    }),
    register: (e) => ({
        fieldErrors: {
            email: e.fieldErrors?.email,
            password: e.fieldErrors?.password1 || e.fieldErrors?.password2,
            lastName: e.fieldErrors?.last_name,
            firstName: e.fieldErrors?.first_name,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // After changes on back end phone numbers (January 2023) errors seems to be located on e.fieldErrors.phone
            telephoneNumber: e.fieldErrors?.phone?.non_field_errors || e.fieldErrors?.phone
        },
        nonFieldErrors: e.nonFieldErrors
    }),
    changePassword: (e) => ({
        fieldErrors: {
            newPassword: e.fieldErrors?.password1 || e.fieldErrors?.password2,
            oldPassword: e.fieldErrors?.old_password
        },
        nonFieldErrors: e.nonFieldErrors
    })
};
const auth = Resource((requesterBuilder) => {
    return {
        refreshToken: methods.create({
            rootPath: `${rootPath}/token-refresh`,
            requesterBuilder,
            fromRaw: fromRaw.refreshToken,
            toRaw: toRaw.refreshToken
        }),
        login: methods.create({
            headers: {
                authorization: null
            },
            rootPath: `${rootPath}/login`,
            fromRaw: fromRaw.login,
            requesterBuilder,
            toRaw: toRaw.login,
            fromError: fromError.login
        }),
        loginMagic: methods.create({
            headers: {
                authorization: null
            },
            rootPath: `${rootPath}/login/magic`,
            requesterBuilder,
            toRaw: toRaw.loginMagic,
            fromRaw: fromRaw.loginMagic
        }),
        loginMagicConfirm: methods.create({
            headers: {
                authorization: null
            },
            rootPath: `${rootPath}/login/magic/confirm`,
            requesterBuilder,
            toRaw: toRaw.loginMagicConfirm,
            fromRaw: fromRaw.loginMagicConfirm
        }),
        register: (query) => methods.create({
            headers: {
                authorization: null
            },
            rootPath: `${rootPath}/registration`,
            fromRaw: fromRaw.register,
            requesterBuilder,
            toRaw: toRaw.register,
            fromError: fromError.register,
            params: {
                query: query || {}
            }
        })(),
        resetPassword: methods.create({
            rootPath: `${rootPath}/password/reset`,
            fromRaw: fromRaw.resetPassword,
            requesterBuilder,
            toRaw: toRaw.resetPassword,
            fromError: fromError.resetPassword
        }),
        sendVerificationEmail: methods.create({
            rootPath: `${rootPath}/registration/send-verify-email`,
            fromRaw: () => { },
            parse: async (x) => x,
            requesterBuilder,
            toRaw: toRaw.sendVerificationEmail,
            fromError: fromError.sendVerificationEmail
        }),
        verifyEmail: methods.create({
            rootPath: `${rootPath}/registration/verify-email`,
            fromRaw: fromRaw.verifyEmail,
            requesterBuilder,
            toRaw: toRaw.verifyEmail
        }),
        resetPasswordConfirm: methods.create({
            rootPath: `${rootPath}/password/reset/confirm`,
            fromRaw: fromRaw.resetPasswordConfirm,
            requesterBuilder,
            toRaw: toRaw.resetPasswordConfirm
        }),
        changePassword: () => requesterBuilder({
            path: `${rootPath}/password/change`,
            requestCtx: {
                method: 'POST',
                toRaw: toRaw.changePassword,
                fromError: fromError.changePassword
            }
        })
    };
});
export default auth;
